import { Dialog, DialogProps } from 'primereact/dialog'
import classes from './ULModal.module.scss'

export interface ULModalProps extends DialogProps {
  children?: any
  theme?: 'ul' | 'prime'
}
export default function ULModal({ theme, ...props }: ULModalProps) {
  return (
    <Dialog
      {...props}
      className={theme === 'prime' ? classes['prime-modal-wrapper'] : classes['ul-modal-wrapper']}
    >
      {props.children}
    </Dialog>
  )
}
